var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import styled from "styled-components";
import { SyfLoader } from "syf-component-library/ui/atoms";
import { H3 } from "syf-component-library/ui/typography";
import { PAGE_NAME } from "../../../const/analytics";
import triggerVantageAnalytics from "../../../helpers/triggerVantageAnalytics";
import VantageTrans from "../VantageTrans";
var LoadingMessage = styled(H3)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: white;\n  padding-top: 40px;\n  max-width: 240px;\n  text-align: center;\n"], ["\n  color: white;\n  padding-top: 40px;\n  max-width: 240px;\n  text-align: center;\n"])));
var LoadingWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: calc(100vh - 75px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"], ["\n  height: calc(100vh - 75px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"])));
var VantageLoader = function () {
    useEffect(function () {
        triggerVantageAnalytics({
            pageName: PAGE_NAME.VANTAGE_LOADER,
        });
    }, []);
    return (_jsxs(LoadingWrapper, { children: [_jsx(SyfLoader, { size: 5 }), _jsx(LoadingMessage, { children: _jsx(VantageTrans, { i18nKey: "labels.findingYourAccount" }) })] }));
};
export default VantageLoader;
var templateObject_1, templateObject_2;
